// Iter-52.55.13 — one authoritative build-version string, baked into
// the JS bundle at build time. Shown in tiny text on the signup screen
// and attached to every funnel event so we can tell an "old cached
// bundle" report apart from a fresh one when a customer sends a
// screenshot.
//
// Bump manually with each user-visible frontend release. `Date` can't
// be used here because that would change on every hot-reload rather
// than every build.
export const BUILD_VERSION = '52.55.13';
